import React from 'react';

const PrivacyPolicyPage = () => (
  <div style={{ background: "#18181b", color: "#eee", maxWidth: 700, margin: "40px auto", padding: 24, borderRadius: 12 }}>
    <h1 style={{ color: "#ffd600" }}>Privacy Policy</h1>
    <p>
      We respect your privacy. This application uses Google login for authentication.<br />
      We do not share your personal information with third parties.<br />
      For more information, see <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#ffd600" }}>Google Privacy Policy</a>.
    </p>
    <p>
      If you have any questions, please contact us.
    </p>
  </div>
);

export default PrivacyPolicyPage;